module.exports = __webpack_public_path__ + "img/ggl-o-it.a3d10092.png";